import type { Cookies as CookiesType } from "@packages/framework";
import type { CookieOptions } from "@packages/framework/src/types/cookieOptions";
import Cookies from "js-cookie";

import type { CookieKey } from "../types/cookieKey.types";

export type DeleteCookieProps = {
  cookies?: CookiesType;
  key: CookieKey;
  options?: Pick<CookieOptions, "domain" | "path" | "secure" | "httpOnly">;
};

export const deleteCookie = ({
  cookies,
  key,
  options = {},
}: DeleteCookieProps) =>
  cookies
    ? cookies.delete({ name: key, ...options })
    : Cookies.remove(key, options);
